import { render, staticRenderFns } from "./myMessageBox.vue?vue&type=template&id=7c3e0194&scoped=true&"
import script from "./myMessageBox.vue?vue&type=script&lang=js&"
export * from "./myMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./myMessageBox.vue?vue&type=style&index=0&id=7c3e0194&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3e0194",
  null
  
)

export default component.exports